import { render, staticRenderFns } from "./TableReport.vue?vue&type=template&id=2fdb3e1f&scoped=true&"
import script from "./TableReport.vue?vue&type=script&lang=js&"
export * from "./TableReport.vue?vue&type=script&lang=js&"
import style0 from "./TableReport.vue?vue&type=style&index=0&id=2fdb3e1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb3e1f",
  null
  
)

export default component.exports